import nativePlugin from '@/utils/nativePlugin.js';
import { usePublicStore } from '@/stores/public.js';
import { buildPrintData58, buildPrintData80, buildTopUpPrintData58, buildTopUpPrintData80, buildGoodsMealsPrintData58, buildGoodsMealsPrintData80 } from '@/utils/printHelper.js';
import { getOrderDetailApi, getChargeOrderDetailApi } from '@/requestPub/interface';

const getShopConfig = () => uni.getStorageSync('shop_config');

export const printTicket = (
    ticket,
    options = {
        printName: 'XP-58',
        copies: 1
    }
) => {
    if (!ticket) {
        return '缺少打印信息';
    }

    if (typeof window !== 'undefined' && window.electronAPI) {
        // 使用 typeof 保护，防止真机环境报错
        const urlOrigin = typeof origin !== 'undefined' ? origin : '';
        window.electronAPI.printCurrentPage({ orderId: '123222', url: urlOrigin + '/#/print', options });
    }
};

export const robotPrint = async (order_id, type) => {
    // 将 Store 的获取放进函数内部，确保调用时 Pinia 已经挂载
    const pubStore = usePublicStore();
    const defaultPrinter = pubStore.defaultPrinter;
    const shop_config = getShopConfig();
    console.log('-----------------', defaultPrinter?.type != 2 || !shop_config?.config?.business?.auto_print_goods_receipt);
    if (defaultPrinter?.type != 2 || !shop_config?.config?.business?.auto_print_goods_receipt) {
        return;
    }

    if (defaultPrinter?.device_info?.envType == 'app') {
        if (!uni?.requireNativePlugin) {
            // return uni.$emit('showToast', {
            //     title: '无法查找到打印机',
            //     type: 'error'
            // });
            return;
        }
        nativePlugin.xinYe.initUsb((res) => {
            console.log('芯烨初始化', res);
            let Lists =
                res?.data[0] != null && res.code == 0
                    ? res?.data.map((item) => {
                          return {
                              ...item,
                              sn: item.deviceName
                          };
                      })
                    : [];
            if (Lists?.length > 0) {
                const exists = Lists.some((item) => item.sn == defaultPrinter?.sn);
                if (exists) {
                    if (type == 1) {
                        getOrderDetailApi(order_id).then((res) => {
                            if (res.code == 200) {
                                getPrintTypes(res.data, type, defaultPrinter, shop_config);
                            }
                        });
                    } else if (type == 2) {
                        console.log('-----------执行没得', order_id);
                        getChargeOrderDetailApi({ id: order_id }).then((res) => {
                            if (res.code == 200) {
                                getPrintTypes(res.data, type, defaultPrinter, shop_config);
                            }
                        });
                    }
                }
            } else {
                // uni.$emit('showToast', {
                //     title: '无法查找到打印机',
                //     type: 'error'
                // });
            }
        });
    } else {
        if (typeof window !== 'undefined' && window?.electronAPI) {
            window.electronAPI.getPrintList().then((res) => {
                let list = res?.map((item) => {
                    return {
                        ...item,
                        productName: item.name
                    };
                });
                const exists = list.some((item) => item.name == defaultPrinter?.name);
                if (exists) {
                    if (type == 1) {
                        getOrderDetailApi(order_id).then((res) => {
                            if (res.code == 200) {
                                printOrder(res.data?.id, res.data, defaultPrinter, shop_config, type);
                            }
                        });
                    } else if (type == 2) {
                        getChargeOrderDetailApi({ id: order_id }).then((res) => {
                            if (res.code == 200) {
                                printOrder(res.data?.id, res.data, defaultPrinter, shop_config, type);
                            }
                        });
                    }
                }
                return;
            });
        }
    }
};

// 通过参数传递 defaultPrinter 和 shop_config
export const getPrintTypes = (dataBill, type, defaultPrinter, shop_config) => {
    let datas;
    if (type == 1) {
        if (defaultPrinter?.device_info?.printSize == 2) {
            datas = buildPrintData80(dataBill, defaultPrinter?.sn, shop_config, defaultPrinter?.template?.config);
        } else {
            datas = buildPrintData58(dataBill, defaultPrinter?.sn, shop_config, defaultPrinter?.template?.config);
        }
        printOrderXinYe(datas, defaultPrinter?.sn);
    } else {
        if (defaultPrinter?.device_info?.printSize == 2) {
            datas = buildTopUpPrintData80(dataBill, defaultPrinter?.sn, shop_config, defaultPrinter?.template?.config);
        } else {
            datas = buildTopUpPrintData58(dataBill, defaultPrinter?.sn, shop_config, defaultPrinter?.template?.config);
        }
        printOrderXinYe(datas, defaultPrinter?.sn);
    }
};

export const printOrderXinYe = async (datas, sn) => {
    try {
        nativePlugin.xinYe.initUsb((res) => {
            console.log('芯烨初始化', res);
            nativePlugin.xinYe.connectUsbPrinter(sn, (data) => {
                console.log('链接打印机', data);
                if (data.code == 0) {
                    nativePlugin.xinYe.printText(datas, () => {
                        uni.$emit('showToast', { title: `打印小票成功`, type: 'success' });
                    });
                } else {
                    uni.$emit('showToast', { title: `打印失败，请检查打印机连接`, type: 'error' });
                }
            });
        });
    } catch (e) {
        console.error('芯烨打印失败', e);
        uni.showToast({ title: '打印失败，请检查芯烨打印机连接', icon: 'error' });
    }
};

// 参数中接收 shop_config
export const printOrder = (id, datas, printer, shop_config, type, part_id = 0,tip) => {
    console.log('-----', id, printer);
    if (typeof window === 'undefined' || !window?.electronAPI) {
        if(tip){
            return
        }
        uni.$emit('showToast', { title: `请先安装客户端`, type: 'error' });
        return;
    }
    window.electronAPI.getPrintList().then((res) => {
                let list = res?.map((item) => {
                    return {
                        ...item,
                        productName: item.name
                    };
                });
                const exists = list.some((item) => item.name == printer?.name);
                
                if(!exists){
                    return
                }
            });
    // location 和 origin，防止真机/非标准浏览器环境报 ReferenceError
    const urlOrigin = typeof origin !== 'undefined' ? origin : '';
    const urlPathname = typeof location !== 'undefined' ? location.pathname : '';

    if (printer.type == 2 && type == 1) {
        let arr = [];
        const finalPartId = typeof part_id === 'object' ? part_id.id || 0 : part_id;
        const printCount = printer.print_num || 1;
        uni.setStorageSync('printData', JSON.stringify(datas));

        if (printer.print_num) {
            for (let i = printCount; i > 0; i--) {
                arr.push({
                    orderId: id,
                    url: urlOrigin + urlPathname + '#/pages/printTxt/printBill?id=' + id + `?&shop_id=${shop_config.id}&print_num=${i}=${finalPartId}`,
                    options: { printName: printer.name }
                });
            }
        } else {
            arr.push({
                orderId: id,
                url: urlOrigin + urlPathname + '#/pages/printTxt/printBill?id=' + id + `?shop_id=${shop_config.id}&print_num=${1}=${finalPartId}`,
                options: { printName: printer.name }
            });
        }
        arr.reverse();
        window.electronAPI.printCurrentPage(arr);
    }

    if (printer.type == 2 && type == 2) {
        let arr = [];
        const finalPartId = typeof part_id === 'object' ? part_id.id || 0 : part_id;
        const printCount = printer.print_num || 1;
        uni.setStorageSync('printDataTop', JSON.stringify(datas));

        if (printer.print_num) {
            for (let i = printCount; i > 0; i--) {
                arr.push({
                    orderId: id,
                    url: urlOrigin + urlPathname + '#/pages/printTxt/printTop?id=' + id + `?&shop_id=${shop_config.id}&print_num=${i}=${finalPartId}`,
                    options: { printName: printer.name }
                });
            }
        } else {
            arr.push({
                orderId: id,
                url: urlOrigin + urlPathname + '#/pages/printTxt/printTop?id=' + id + `?shop_id=${shop_config.id}&print_num=${1}=${finalPartId}`,
                options: { printName: printer.name }
            });
        }
        arr.reverse();
        window.electronAPI.printCurrentPage(arr);
    }

    if (printer.type == 2 && type == 3) {
        let arr = [];
        const finalPartId = typeof part_id === 'object' ? part_id.id || 0 : part_id;
        const printCount = printer.print_num || 1;
        uni.setStorageSync('printDataHandover', JSON.stringify(datas));

        if (printer.print_num) {
            for (let i = printCount; i > 0; i--) {
                arr.push({
                    orderId: id,
                    url: urlOrigin + urlPathname + '#/pages/printTxt/printHandover?id=' + id + `?&shop_id=${shop_config.id}&print_num=${i}=${finalPartId}`,
                    options: { printName: printer.name }
                });
            }
        } else {
            arr.push({
                orderId: id,
                url: urlOrigin + urlPathname + '#/pages/printTxt/printHandover?id=' + id + `?shop_id=${shop_config.id}&print_num=${1}=${finalPartId}`,
                options: { printName: printer.name }
            });
        }
        arr.reverse();
        window.electronAPI.printCurrentPage(arr);
    }
    if (printer.type == 2 && type == 4) {
        let arr = [];
        const finalPartId = typeof part_id === 'object' ? part_id.id || 0 : part_id;
        const printCount = printer.print_num || 1;
        uni.setStorageSync('printDataDailyCut', JSON.stringify(datas));

        if (printer.print_num) {
            for (let i = printCount; i > 0; i--) {
                arr.push({
                    orderId: id,
                    url: urlOrigin + urlPathname + '#/pages/printTxt/printDaily?id=' + id + `?&shop_id=${shop_config.id}&print_num=${i}=${finalPartId}`,
                    options: { printName: printer.name }
                });
            }
        } else {
            arr.push({
                orderId: id,
                url: urlOrigin + urlPathname + '#/pages/printTxt/printDaily?id=' + id + `?shop_id=${shop_config.id}&print_num=${1}=${finalPartId}`,
                options: { printName: printer.name }
            });
        }
        arr.reverse();
        window.electronAPI.printCurrentPage(arr);
    }
    // 商品/餐食下单小票
    if (printer.type == 2 && type == 5) {
        let arr = [];
        const finalPartId = typeof part_id === 'object' ? part_id.id || 0 : part_id;
        const printCount = printer.print_num || 1;
        uni.setStorageSync('printDataGoodsMeals', JSON.stringify(datas));

        if (printer.print_num) {
            for (let i = printCount; i > 0; i--) {
                arr.push({
                    orderId: id,
                    url: urlOrigin + urlPathname + '#/pages/printTxt/printGoodsMeals?id=' + id + `?&shop_id=${shop_config.id}&print_num=${i}=${finalPartId}`,
                    options: { printName: printer.name }
                });
            }
        } else {
            arr.push({
                orderId: id,
                url: urlOrigin + urlPathname + '#/pages/printTxt/printGoodsMeals?id=' + id + `?shop_id=${shop_config.id}&print_num=${1}=${finalPartId}`,
                options: { printName: printer.name }
            });
        }
        arr.reverse();
        window.electronAPI.printCurrentPage(arr);
    }
};

// ================ 商品/餐食下单自动打印（MQTT 推送等被动触发场景） ================

/**
 * 商品/餐食自动打印
 * 适用于 MQTT 推送等被动场景：融合 orderIndex.vue 中 ribotPrint 的打印能力
 * 与 robotPrint 的环境/设备匹配逻辑，优先判断配置开关、环境、设备匹配后才执行打印。
 *
 * @param {Object} printData - 打印数据 { table_name, order_time, goods, meals, id }
 */
export const autoPrintGoodsMeals = (printData) => {
    const pubStore = usePublicStore();
    const defaultPrinter = pubStore.defaultPrinter;
    const shop_config = getShopConfig();

    // 1. 配置开关检查（与 orderIndex.vue 取值方式一致）
    if (!shop_config?.config?.business?.place_order_auto_print) {
        return;
    }

    // 2. 默认打印机检查
    if (!defaultPrinter) {
        return;
    }

    // 3. USB 打印机（type == 2）→ 需要设备匹配
    if (defaultPrinter.type == 2) {
        // 3a. APP 环境（Android 收银机）
        if (defaultPrinter?.device_info?.envType == 'app') {
            if (!uni?.requireNativePlugin || !defaultPrinter?.sn) {
                return;
            }

            // 设备匹配：查询已连接的 USB 打印机列表，比对 SN
            nativePlugin.xinYe.initUsb((res) => {
                const lists =
                    res?.code == 0 && res?.data?.length > 0
                        ? res.data.map((item) => ({ ...item, sn: item.deviceName }))
                        : [];
                if (lists.length === 0) return;

                const exists = lists.some((item) => item.sn == defaultPrinter?.sn);
                if (!exists) return;

                // 设备匹配成功 → 构建打印数据
                let datas = {};
                if (defaultPrinter?.device_info?.printSize == 2) {
                    datas = buildGoodsMealsPrintData80(printData, defaultPrinter?.sn, shop_config);
                } else {
                    datas = buildGoodsMealsPrintData58(printData, defaultPrinter?.sn, shop_config);
                }
                printOrderXinYe(datas, defaultPrinter?.sn);
            });
            return;
        }

        // 3b. Electron 桌面环境
        if (typeof window !== 'undefined' && window?.electronAPI) {
            if (!defaultPrinter?.name) {
                return;
            }

            // 设备匹配：查询桌面打印机列表，比对名称
            window.electronAPI.getPrintList().then((res) => {
                const list = res?.map((item) => ({ ...item, productName: item.name })) || [];
                const exists = list.some((item) => item.name == defaultPrinter?.name);
                if (!exists) return;

                // 设备匹配成功 → 通过 printOrder type=5 打印
                printOrder(printData?.id, printData, defaultPrinter, shop_config, 5, 0, true);
            });
            return;
        }

        // USB 类型但非 APP 也非 Electron → 跳过
        return;
    }

    // 4. 云打印机（type != 2）→ 无需设备匹配，直接调用云打印 API
    // if (!defaultPrinter?.id) {
    //     return;
    // }
    // printClound({
    //     id: printData?.id,
    //     printer_id: defaultPrinter.id
    // });
};